/* KitHouse — varukorgens CRO-moduler (fri frakt-bar + upsell).
   Laddas av kithouse-header. Texter och inställningar kommer från
   <script id="kh-cart-cro-config"> (Liquid + locales), så språket följer kundens val.
   Används så här i varukorgslådans render():
     html += KH.cartCro.shipbar(cart);
     KH.cartCro.upsell(element, cart, function(variantId){ return promise; });  */
(function (K) {
  'use strict';

  var cfg = null;
  var recCache = {};

  function config() {
    if (cfg) return cfg;
    var el = document.getElementById('kh-cart-cro-config');
    try { cfg = JSON.parse(el ? el.textContent : '{}'); } catch (e) { cfg = {}; }
    cfg.i18n = cfg.i18n || {};
    cfg.exclude = cfg.exclude || [];
    cfg.manual = cfg.manual || [];
    return cfg;
  }
  function t(key) { return config().i18n[key] || ''; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cur() { return K.cur || 'SEK'; }
  function fmt(cents) { return K.fmt ? K.fmt(cents) : (cents / 100).toLocaleString('sv-SE') + ' kr'; }
  /* SEK-belopp -> cent i kundens valuta (samma regler som kh-locale-globals) */
  function conv(kr) { return K.conv ? K.conv(kr) : Math.round(kr * 100); }
  function url(u) { return K.url ? K.url(u) : u; }

  /* Fri frakt-gräns i kundens valuta (cent) */
  function freeCents() {
    var c = config();
    return cur() === 'SEK' ? (c.freeShip || 500) * 100 : (K.freeShipCents || conv(c.freeShip || 500));
  }
  function isExcluded(item) {
    return config().exclude.indexOf(item.variant_id) !== -1 || item.price === 0;
  }

  /* ============ 1. FRI FRAKT-BAR ============ */
  function shipbar(cart) {
    var c = config();
    // Fraktskydd och tillägg räknas inte mot fri frakt eller rabattstegen
    var sub = (cart.total_price || 0) - (cart.items || []).reduce(function (s, i) { return isExcluded(i) ? s + (i.final_line_price || 0) : s; }, 0);
    var FREE_C = freeCents();
    var STOP3_C = conv(c.stop3 || 1200);
    var discTxt = fmt(conv(100));

    function left(limitC) {
      var v = Math.max(0, limitC - sub);
      if (cur() === 'SEK') v = Math.ceil(v / 100) * 100;
      return '<strong>' + esc(fmt(v)) + '</strong>';
    }
    function stopTxt(v) { return cur() === 'SEK' ? Math.round(v / 100) + ' kr' : fmt(v); }

    /* KH CRO-lab: räcker en tröja till för fri frakt, säg det i tröjor i stället för kronor */
    var unit = (cart.items || []).reduce(function (m, i) { return !isExcluded(i) && (!m || i.price < m) ? i.price : m; }, 0);
    var oneMore = sub > 0 && sub < FREE_C && unit && (FREE_C - sub) <= unit && t('one_more_free');
    var label = oneMore ? esc(t('one_more_free')).replace('[amount]', left(FREE_C))
              : sub < FREE_C ? esc(t('left_to_free')).replace('[amount]', left(FREE_C))
              : sub < STOP3_C ? esc(t('left_to_discount')).replace('[amount]', left(STOP3_C)).replace('[discount]', esc(discTxt))
              : esc(t('max_discount'));
    var pct = Math.max(0, Math.min(100, (sub / (STOP3_C || 1)) * 100));
    var stops = [
      { at: 0, txt: t('start'), align: 'start' },
      { at: FREE_C, txt: t('free_shipping'), align: 'center' },
      { at: STOP3_C, txt: t('discount_label').replace('[discount]', discTxt), align: 'end' }
    ];

    return '<div class="kh-cfs' + (sub >= FREE_C ? ' is-free' : '') + '">'
      + '<div class="kh-cfs-head"><span class="kh-cfs-label">' + label + '</span>'
      +   '<span class="kh-cfs-note">' + esc(t('activates_at_checkout')) + '</span></div>'
      + '<div class="kh-cfs-track" role="progressbar" aria-label="' + esc(t('free_shipping')) + '"'
      +   ' aria-valuemin="0" aria-valuemax="' + STOP3_C + '" aria-valuenow="' + Math.min(sub, STOP3_C) + '">'
      +   '<div class="kh-cfs-fill" style="width:' + pct.toFixed(1) + '%"></div>'
      +   stops.map(function (s) {
            return '<span class="kh-cfs-dot' + (sub >= s.at ? ' is-reached' : '') + '" style="left:' + ((s.at / STOP3_C) * 100).toFixed(1) + '%"></span>';
          }).join('')
      + '</div>'
      + '<div class="kh-cfs-stops">'
      +   stops.map(function (s) {
            return '<div class="kh-cfs-stop kh-cfs-stop--' + s.align + '"><strong>' + esc(stopTxt(s.at)) + '</strong>' + esc(s.txt) + '</div>';
          }).join('')
      + '</div></div>';
  }

  /* ============ 2. UPSELL / CROSS-SELL ============ */
  /* Normaliserar både Shopify-rekommendationer och manuella produkter (upsell-kollektion) */
  function baseVariants(p) {
    var vs = p.variants || [];
    if (!vs.length) return [];
    // Bara grundvarianten per storlek (t.ex. "Utan tryck / Utan badge") — tryck väljs på produktsidan.
    var first = vs[0];
    return vs.filter(function (v) { return v.option2 === first.option2 && v.option3 === first.option3; });
  }
  function image(p) {
    var src = p.featured_image;
    if (src && typeof src === 'object') src = src.url || src.src;
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=260';
  }

  function fetchRecs(productId) {
    if (recCache[productId]) return recCache[productId];
    var key = 'khRecs:' + (K.lang || '') + ':' + productId;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) return (recCache[productId] = Promise.resolve(JSON.parse(hit)));
    } catch (e) {}
    function get(intent) {
      return fetch(url('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=' + intent))
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; });
    }
    // Kompletterande produkter (shorts, strumpor, patchar — styrs i Search & Discovery) först, annars relaterade.
    recCache[productId] = get('complementary').then(function (list) {
      return list.length ? list : get('related');
    }).then(function (list) {
      try { sessionStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
      return list;
    }).catch(function () { return []; });
    return recCache[productId];
  }

  function upsell(el, cart, onAdd) {
    if (!el) return Promise.resolve();
    var items = (cart.items || []).filter(function (i) { return !isExcluded(i); });
    if (!items.length) { el.innerHTML = ''; return Promise.resolve(); }

    var inCart = {};
    items.forEach(function (i) { inCart[i.product_id] = true; });
    // cart.items[0] är senast tillagd — rekommendera utifrån den, och förvälj kundens storlek.
    var seed = items[0];
    var sizeHint = seed.options_with_values && seed.options_with_values[0] ? seed.options_with_values[0].value : null;

    return fetchRecs(seed.product_id).then(function (recs) {
      var seen = {};
      // KH CRO-lab: rekommendationer för produkten i varukorgen först, de fasta upsell-produkterna sist
      var list = recs.concat(config().manual).filter(function (p) {
        if (!p || seen[p.id] || inCart[p.id] || p.available === false) return false;
        seen[p.id] = true;
        return baseVariants(p).some(function (v) { return v.available; });
      }).slice(0, 4);

      if (!list.length) { el.innerHTML = ''; return; }
      el.innerHTML = renderUpsell(list, cart, sizeHint);
      bindUpsell(el, list, onAdd);
    });
  }

  function renderUpsell(list, cart, sizeHint) {
    var FREE_C = freeCents(), sub = (cart.total_price || 0) - (cart.items || []).reduce(function (s, i) { return isExcluded(i) ? s + (i.final_line_price || 0) : s; }, 0);
    var html = '<div class="kh-xs"><h4 class="kh-xs-title">' + esc(t('upsell_title')) + '</h4><div class="kh-xs-row">';
    list.forEach(function (p, idx) {
      var vs = baseVariants(p);
      var pre = vs.filter(function (v) { return v.available && v.option1 === sizeHint; })[0];
      var price = (pre || vs[0]).price;
      var unlocks = sub < FREE_C && sub + price >= FREE_C;
      var select = '';
      if (vs.length > 1) {
        select = '<select class="kh-xs-size" data-xs-size aria-label="' + esc(t('upsell_choose_size')) + '">'
          + '<option value="">' + esc(t('upsell_choose_size')) + '</option>'
          + vs.map(function (v) {
              return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + (pre && pre.id === v.id ? ' selected' : '') + '>' + esc(v.option1) + '</option>';
            }).join('')
          + '</select>';
      }
      html += '<div class="kh-xs-card" data-xs-idx="' + idx + '">'
        + '<a href="' + esc(p.url) + '" class="kh-xs-img"><img src="' + esc(image(p)) + '" alt="" loading="lazy" width="130" height="130"></a>'
        + '<a href="' + esc(p.url) + '" class="kh-xs-name">' + esc(p.title) + '</a>'
        + '<div class="kh-xs-price">' + esc(fmt(price)) + '</div>'
        + (unlocks ? '<div class="kh-xs-flag">' + esc(t('upsell_unlocks_free')) + '</div>' : '')
        + select
        + '<button type="button" class="kh-xs-add" data-xs-add>' + esc(t('upsell_add')) + '</button>'
        + '</div>';
    });
    return html + '</div></div>';
  }

  function bindUpsell(el, list, onAdd) {
    el.querySelectorAll('[data-xs-idx]').forEach(function (card) {
      var p = list[+card.getAttribute('data-xs-idx')];
      var btn = card.querySelector('[data-xs-add]');
      var sel = card.querySelector('[data-xs-size]');
      if (sel) sel.addEventListener('change', function () { sel.classList.remove('is-error'); });
      btn.addEventListener('click', function () {
        var id = sel ? sel.value : (baseVariants(p)[0] || {}).id;
        if (!id) { sel.classList.add('is-error'); sel.focus(); return; }
        btn.disabled = true;
        btn.textContent = t('upsell_adding');
        Promise.resolve(onAdd(parseInt(id, 10))).catch(function () {
          btn.disabled = false;
          btn.textContent = t('upsell_add');
        });
      });
    });
  }

  K.cartCro = { shipbar: shipbar, upsell: upsell };
})(window.KH = window.KH || {});
